import React from "react";
import { useTranslation } from "react-i18next";
import PageHeadingWithImage from "../../components/pageheading/PageHeadingWithImage";
import "../../stylesheet/pages/HubPage.scss";
import OurJourney from "../../components/about/ourjourney/OurJourney";
import InfoSectionWithImage from "../../components/about/infosectionwithimage/InfoSectionWithImage";
import SkyRocket from "../../components/about/skyrocket/SkyRocket";
import ZePeople from '../../components/about/zapeople/ZePeople';
import AboutZeFiFaq from "../../components/about/aboutzefifaq/AboutZeFiFaq";
import ZePartners from "../../components/about/zepartners/ZePartners";

const AboutZeFiPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="main">
      <PageHeadingWithImage
        className="about-zefi"
        title={t("about-zefi.heading.title")}
        subtitle={t("about-zefi.heading.subtitle")}
        body={t("about-zefi.heading.body")}
      />
      <div className="container">
        <OurJourney />
      </div>
      <InfoSectionWithImage
        title={t("about-zefi.inclusion.title")}
        body={t("about-zefi.inclusion.body")}
        className="inclusion mt-4 mb-2"
      />
      <InfoSectionWithImage
        title={t("about-zefi.got-your-back.title")}
        body={t("about-zefi.got-your-back.body")}
        className="got-your-back"
        flipped={true}
      />
      <div className="container my-4">
        <SkyRocket />
      </div>
      <InfoSectionWithImage
        title={t("about-zefi.privacy-security.title")}
        body={t("about-zefi.privacy-security.body")}
        className="privacy-security"
      />
      <ZePartners />
      <div className="container">
        <ZePeople />
      </div>
      <AboutZeFiFaq/>
    </div>
  );
};

export default AboutZeFiPage;
